var map = {
	"./babytv.png": "f3c2",
	"./coolmath.png": "afa7",
	"./disney.png": "c8cc",
	"./howstuffworks.png": "03ca",
	"./nationalgeog.png": "83c4",
	"./pbs.png": "b58d",
	"./primary_games.png": "4cbc",
	"./sesame_street.png": "19b3",
	"./starfall.png": "8011",
	"./timetokids.png": "1857",
	"./youtube_kids.png": "2955"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3722";